import apiService from "@/lib/api";

const ROLE_BASE = "/api/v2/roles";

export const RoleService = {
    fetchRolesList: async ({
        page = 1,
        per_page = 10,
        pagination = true,
        search = '',
        ...param
    }) => {
        const params = {
            page,
            per_page,
            search,
            pagination,
            ...param
        };
        try {
            const response = await apiService.getSecure(`${ROLE_BASE}`, { params });
            return response.data;
        } catch (error) {
            console.error('Error while fetching list:', error);
            throw error;
        }
    },

    createRole: async (payload) => {
        try {
            const response = await apiService.postSecure(`${ROLE_BASE}`, payload);
            return response.data;
        } catch (error) {
            console.error('Error while creating tenant:', error);
            throw error;
        }
    },

    updateRole: async (id, payload) => {
        try {
            const response = await apiService.patch(`${ROLE_BASE}/${id}`, payload);
            return response.data;
        } catch (error) {
            console.error('Error while creating tenant:', error);
            throw error;
        }
    },

    deleteRole: async (id, reason) => {
        // Backend expects `reason` as a query param (see roles/router.py —
        // `reason: str = Query(..., min_length=10)`). The previous version
        // built a payload but never sent it, so FastAPI returned 422 for
        // the missing query param. Send via `params` so axios serialises
        // it into the URL.
        try {
            const response = await apiService.delete(`${ROLE_BASE}/${id}`, {
                params: { reason },
            });
            return response.data;
        } catch (error) {
            console.error('Error while deleting role:', error);
            throw error;
        }
    },


};

